import { AcceptOfferModal, SendOfferModal } from '../../../../../components/Offers';
import { AcceptTopAlternativeOfferModal } from '../AcceptAlternativeBidOffer';
import { AcceptHighBidModal } from '../AcceptHighBidModal';
import { AcceptTopOfferModal } from '../AcceptTopOfferModal';
import { DropReservePriceModal } from '../DropReservePriceModal';
import EditVehicleBidModal from '../EditVehicleBidModal/index';
import { MakeAlternativeOfferModal } from '../MakeAlternativeOfferModal';

export const DashboardModals = ({ currentVehicle: vehicle }) => {
  return (
    <>
      <EditVehicleBidModal
        form={`vehicleEditModal-${vehicle.id}`}
        initialValues={{ ...vehicle, alternative_offer: vehicle.active_alternative_offer?.amount }}
      />
      <SendOfferModal maxAmount={vehicle.reserve_price} form={`sendVehicleOffer-${vehicle.id}`} vehicle={vehicle} />
      <AcceptHighBidModal vehicle={vehicle} />
      <AcceptOfferModal vehicleId={vehicle.id} />
      <AcceptTopOfferModal currentVehicle={vehicle} />
      <DropReservePriceModal currentVehicle={vehicle} />
      <MakeAlternativeOfferModal currentVehicle={vehicle} />
      <AcceptTopAlternativeOfferModal currentVehicle={vehicle} />
    </>
  );
};
